module.exports = __webpack_public_path__ + "img/electronic_enabled_selected.0ff7dfd5.svg";